import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {PopupMessage} from "./popup-message";
import {PopupMessageService} from "./popup-message.service";

@Component({
  selector: 'popup-message',
  template: `
    <div *ngIf="message != null" class="modal modal-notification" 
         style="display: block;" role="dialog" (click)="close()">
      <div class="modal-dialog" role="document" (click)="onEvent($event)" style="z-index: 10Это000;">
        <div class="modal-content">
          <div class="modal-header" [ngClass]="{'danger': message.isDanger}">
            <div class="block-icon" [ngClass]="{'icon-success': !message.isDanger,
             'icon-danger': message.isDanger}"><i class="far fa-bell"></i></div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h3 class="text-center mb-4">{{message.title}}</h3>
            <p class="mb-5">{{message.text}}</p>
<!--            <button type="button" class="btn btn-primary m-auto d-block">Перейти к оплате</button>-->
          </div>
        </div>
      </div>
    </div>
  `
})
export class PopupMessageComponent implements OnInit {

    text: string;
    message: PopupMessage;

    private callback: Function;

    constructor(private popupMessageService: PopupMessageService, private _cdRef: ChangeDetectorRef) {
        this.popupMessageService.show = this.show.bind(this);
    }

    ngOnInit() {}
    
    show(m: PopupMessage, callback?: Function): void {
        this.message = m;
        this.callback = callback;
        this._cdRef.detectChanges();
    }

    close(): void {
      this.message = null;
      this._cdRef.detectChanges();
      if(this.callback != null) {
        this.callback();
      }
      this.callback = undefined;
    }

    onEvent($event: MouseEvent) {
        $event.stopPropagation();
    }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_commonComp/popup-message/popup-message.component.ts